import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed top-0 md:top-6 left-0 right-0 z-50 px-0 md:px-6">
            <nav className={`flex justify-between items-center px-6 md:px-8 py-4 md:py-3 max-w-5xl mx-auto w-full bg-white/90 backdrop-blur-md border-b md:border border-slate-200 md:shadow-lg md:rounded-2xl transition-all duration-300 ${isOpen ? 'h-[100dvh] md:h-auto items-start md:items-center flex-col md:flex-row' : 'h-auto'}`}>
                {/* Left: Logo & Mobile Toggle */}
                <div className="flex items-center justify-between w-full md:w-auto">
                    <div className="flex items-center gap-2">
                        <img
                            src="/new_logo.png"
                            alt="Vetobase AI"
                            className="w-9 h-9 rounded-lg object-contain"
                        />
                        <span className="text-xl font-bold tracking-tight text-blue-700">Vetobase<span className="text-blue-500">AI</span></span>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="p-2 md:hidden text-slate-600 hover:text-blue-700 transition-colors"
                    >
                        {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>

                {/* Center: Navigation Links */}
                <div className={`${isOpen ? 'flex flex-col mt-12 gap-8 w-full' : 'hidden md:flex'} items-center gap-8`}>
                    {[
                        { label: 'Partners', href: '#partners' },
                        { label: 'Solutions', href: '#solutions' },
                    ].map((link) => (
                        <a
                            key={link.label}
                            href={link.href}
                            onClick={() => setIsOpen(false)}
                            className="text-[16px] md:text-[13px] font-medium text-slate-500 hover:text-blue-700 transition-colors w-full text-center md:w-auto"
                        >
                            {link.label}
                        </a>
                    ))}
                </div>

                {/* Right: Contact Button */}
                <div className={`${isOpen ? 'mt-auto mb-12 w-full px-4' : 'hidden md:block'}`}>
                    <a
                        href="#contact"
                        onClick={() => setIsOpen(false)}
                        className="block w-full md:w-auto text-center bg-blue-700 text-white px-8 md:px-6 py-4 md:py-2 rounded-xl text-base md:text-sm font-semibold hover:shadow-lg hover:shadow-blue-700/20 transition-all active:scale-95"
                    >
                        Contact
                    </a>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
